import React from 'react';

export default function ImageRenderer({ firstName, lastName }) {
  return (
    <div className="image-renderer-container">
      <div className="image-renderer-text">
        {firstName?.charAt(0)?.toUpperCase()}
        {lastName?.charAt(0)?.toUpperCase()}
      </div>
    </div>
  );
}
